import { useEffect } from "react";
import { useSnackbar } from "notistack";
import { setSnackbarEnqueue } from "../utils/snackbar";

// Component to initialize global snackbar access for use in axios interceptors
const SnackbarInitializer = () => {
  const { enqueueSnackbar: originalEnqueueSnackbar } = useSnackbar();

  useEffect(() => {
    // Wrap enqueueSnackbar to add logging when called directly from components
    const wrappedEnqueueSnackbar = (message, options = {}) => {
      const stack = new Error().stack;
      const caller = stack?.split('\n')[2]?.trim() || 'unknown';
      
      console.log('[SNACKBAR] enqueueSnackbar called DIRECTLY from component:', {
        message,
        variant: options.variant || 'default',
        caller,
        timestamp: new Date().toISOString()
      });
      console.log('[SNACKBAR] Direct call stack trace:', stack);
      
      return originalEnqueueSnackbar(message, options);
    };

    setSnackbarEnqueue(wrappedEnqueueSnackbar);
  }, [originalEnqueueSnackbar]);

  return null;
};

export default SnackbarInitializer;
